var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-right",class:{ opacity50: _vm.disabled }},[_c('div',{staticClass:"ui-type-body font-weight-bold"},[_c('span',{staticClass:"mr-2",class:{ strikethrough: _vm.disabled }},[_vm._v(_vm._s(_vm.presentQuatity()))])])])}
var staticRenderFns = []

export { render, staticRenderFns }